import React from "react";
import AnalyticsDashboardLayer from "../Trading/AnalyticsDashboardLayer";

const DashBoardLayerOne = () => {
    return (
        <div className="mt-24">
            <AnalyticsDashboardLayer mode="dashboard" />
        </div>
    );
};

export default DashBoardLayerOne;
